import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Proveedor } from '../_models/proveedor.model';
import { Fichero } from '../_models/fichero.model';

export enum ProveedorInclude {
  Usuarios,
  Contactos,
  Condiciones,
  Categorias,
  Provincia,
  Marcas,
}

export interface ProveedorParams {
  includes?: ProveedorInclude[];
  inicial?: string;
  id?: number;
  ids?: number[];
  buscar?: string;
  cantidad?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProveedorService {
  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/Proveedor`;

  constructor() {}

  getProveedores(params?: ProveedorParams): Observable<Proveedor[]> {
    const httpParams = new HttpParams({ fromObject: { ...params } });
    return this.http.get<Proveedor[]>(`${this.apiUrl}/lista`, {
      params: httpParams,
    });
  }

  getNuevosProveedores(
    cantidad: number,
    params?: ProveedorParams,
  ): Observable<Proveedor[]> {
    const httpParams = new HttpParams({ fromObject: { ...params } }).set(
      'cantidad',
      cantidad.toString(),
    );
    return this.http.get<Proveedor[]>(`${this.apiUrl}/lista-nuevos`, {
      params: httpParams,
    });
  }

  getProveedor(params?: ProveedorParams): Observable<Proveedor> {
    const httpParams = new HttpParams({ fromObject: { ...params } });
    return this.http.get<Proveedor>(`${this.apiUrl}`, { params: httpParams });
  }

  crearProveedor(proveedor: Partial<Proveedor>) {
    return this.http.post(`${this.apiUrl}`, proveedor);
  }

  actualizarProveedor(id: number, proveedor: Partial<Proveedor>) {
    return this.http.put(`${this.apiUrl}/${id}`, proveedor);
  }

  eliminarProveedor(id: number) {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  subirLogo(idProveedor: number, file: File) {
    const formData = new FormData();
    formData.append('idProveedor', idProveedor.toString());
    formData.append('fichero', file);
    return this.http.post(`${this.apiUrl}/subir-logo-empresa`, formData);
  }

  eliminarLogo(idProveedor: number) {
    return this.http.delete(
      `${this.apiUrl}/borrar-logo-empresa/${idProveedor}`,
    );
  }

  subirAnexo(idProveedor: number, file: File) {
    const formData = new FormData();
    formData.append('idProveedor', idProveedor.toString());
    formData.append('fichero', file);
    return this.http.post(`${this.apiUrl}/subir-anexo`, formData);
  }

  getAnexo(idProveedor: number): Observable<Fichero> {
    const httpParams = new HttpParams().set(
      'id',
      idProveedor.toString(),
    );
    return this.http.get<Fichero>(`${this.apiUrl}/obtener-anexo`, {
      params: httpParams,
    });
  }

  eliminarAnexo(idProveedor: number) {
    return this.http.delete(`${this.apiUrl}/borrar-anexo/${idProveedor}`);
  }

  obtenerTarifa(idProveedor: number): Observable<Fichero> {
    const httpParams = new HttpParams().set('id', idProveedor.toString());
    return this.http.get<any>(`${this.apiUrl}/obtener-tarifa`, {
      params: httpParams,
    });
  }

  importarDatos(idProveedor: number, excel: File) {
    const formData = new FormData();
    formData.append('idProveedor', idProveedor.toString());
    formData.append('excel', excel);
    return this.http.put(`${this.apiUrl}/importar-excel-proveedor`, formData);
  }

  registrarVisitaCondiciones(idProveedor: number) {
    return this.http.post(`${this.apiUrl}/registrar-condiciones`, {
      idProveedor: idProveedor,
    });
  }

  registrarVisita(proveedor: any): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/registrar-busqueda`, proveedor);
  }
}
